export interface ActiveTaskType {
  task_id: string;
  name: string;
  state: string;
  hostname: string;
  pid: number | null;
  worker: string;
  started_at: string | null;
  updated_at: string | null;
  elapsed_seconds: number | null;
  progress_count: number | null;
  total: number | null;
  unit: string;
}

export interface FailedTaskType {
  task_id: string;
  name: string;
  state: string;
  failed_at: string | null;
  hostname: string;
  worker: string;
  error: string;
}

export interface RegisteredTaskType {
  name: string;
  is_revoked: boolean;
  is_periodic: boolean;
}

export const TASK_CONTROL_ACTIONS = {
  RESTORE: 'restore',
  REVOKE: 'revoke',
  RUN: 'run',
} as const;

export type TaskControlActionType = (typeof TASK_CONTROL_ACTIONS)[keyof typeof TASK_CONTROL_ACTIONS];

export interface TaskControlPayloadType {
  task_name: string;
  action: TaskControlActionType;
}

export interface TaskControlResultType {
  task_name: string;
  is_revoked: boolean;
  task_id?: string;
}

export interface TaskQueueStatusType {
  pending_count: number;
  executing_count: number;
  scheduled_count: number;
  revoked_count: number;
  revoked_tasks: string[];
  registered_tasks: RegisteredTaskType[];
  can_manage_tasks: boolean;
  active_tasks: ActiveTaskType[];
  recent_failures: FailedTaskType[];
  fetched_at: string;
}

export interface PendingTaskCountType {
  name: string;
  count: number;
}

export interface PendingTaskBreakdownType {
  total: number;
  scanned_count: number;
  is_truncated: boolean;
  unknown_count: number;
  tasks: PendingTaskCountType[];
  fetched_at: string;
}
